module.exports = __webpack_public_path__ + "static/male_icon-6ae400621e3084314fa0c571823b3a5e.svg";